/* eslint-disable import/prefer-default-export */
import type { ApolloClient } from '@apollo/client';
import { gql } from '@apollo/client';
import { USA_AND_TERRITORIES } from '@airtm/utils/dist/constants';
import { PARTNER } from '@airtm/utils/dist/constants/userRoles';
import type { Auth__User } from 'types/__generated__/graphql-global-types';

type AuthUserLocalFields = Pick<Auth__User, 'country' | 'roles'>;

const AUTH_USER_LOCAL_FIELDS_FRAGMENT = gql`
  fragment AuthUserLocalFields on Auth__User {
    __typename
    country
    roles
  }
`;

const readAuthUserFromCache = (root: Auth__User, client: ApolloClient) => {
  const cacheId = client.cache.identify(root);
  if (!cacheId) return null;

  return client.cache.readFragment<AuthUserLocalFields>({
    id: cacheId,
    fragment: AUTH_USER_LOCAL_FIELDS_FRAGMENT,
  });
};

export const resolvers = {
  Auth__User: {
    canUseP2P: (root: Auth__User, _: never, { client }: { client: ApolloClient }) => {
      const cachedUser = readAuthUserFromCache(root, client);
      const country = cachedUser?.country ?? root?.country ?? '';

      return !USA_AND_TERRITORIES.includes(country);
    },

    isPartner: (root: Auth__User, _: never, { client }: { client: ApolloClient }) => {
      const cachedUser = readAuthUserFromCache(root, client);
      const roles = cachedUser?.roles ?? root?.roles ?? [];

      return !!roles?.includes(PARTNER);
    },
  },
};
